"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChart = void 0;
const React = require("react");
const chart_1 = require("../chart");
const bar_chart_enum_1 = require("./bar-chart.enum");
exports.BarChart = React.forwardRef((props, ref) => {
    const optionsBar = Object.assign(Object.assign({ indexAxis: props.barType === bar_chart_enum_1.Type.VERTICAL ? 'x' : 'y', plugins: {
            legend: {
                display: false,
            },
        }, layout: {
            padding: {
                right: 50,
                left: 20,
                top: 20,
                bottom: 20,
            },
        } }, props.options), { scales: {
            y: {
                grid: {
                    display: false,
                    drawBorder: false,
                },
            },
            x: {
                grid: {
                    display: false,
                    drawBorder: false,
                },
            },
        } });
    return React.createElement(chart_1.ChartJS, Object.assign({}, props, { type: 'bar', options: optionsBar, ref: ref }));
});
